import { render, staticRenderFns } from "./FormularioServicio.vue?vue&type=template&id=379108d3&"
import script from "./FormularioServicio.vue?vue&type=script&lang=ts&"
export * from "./FormularioServicio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports